import * as React from "react";
import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useApiClient } from "../../../api";
import { useNavigate } from "react-router-dom";

export const CreateTeacherDialog = ({ open, setOpen, schools }) => {
  const ApiClient = useApiClient();
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [school, setSchool] = useState({});

  useEffect(() => {
    if (schools.length > 0) {
      setSchool(schools[0]);
    }
  }, [schools]);

  const handleSubmit = async () => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Incorrect or missing email");
      return;
    } else setError("");
    console.log(school);
    try {
      const response = await ApiClient.schools.createTeacher({
        firstName: firstName,
        lastName: lastName,
        email: email,
        school: school.id,
      });
      if (response.success) {
        setOpen(false);
        navigate(`view/${response.teacher.id}`);
      } else {
        console.log("Failed to create teacher");
      }
    } catch (error) {
      console.error("Failed to create teacher", error);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      slotProps={{
        paper: {
          component: "form",
          sx: { backgroundImage: "none" },
        },
      }}
    >
      <DialogTitle>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography variant={"h4"}>Add a new Teacher</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        {error && <Alert variant={"error"}>{error}</Alert>}
        <Stack spacing={2} sx={{ mt: 1 }}>
          <FormControl>
            <TextField
              label={"First Name"}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              fullWidth
            />
          </FormControl>
          <FormControl>
            <TextField
              label="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              fullWidth
            />
          </FormControl>
          {schools.length !== 1 && (
            <FormControl>
              <InputLabel id="schools-label">School</InputLabel>
              <Select
                labelId={"schools-label"}
                label={"School"}
                value={school}
                onChange={(e) => {
                  setSchool(e.target.value);
                }}
                fullWidth
              >
                {schools.map((school) => (
                  <MenuItem key={school.id} value={school}>
                    {school.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <FormControl>
            <TextField
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
            />
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant={"outlined"}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant={"contained"}
          disabled={!firstName}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};
